import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PageCode } from '@gov-nx/module/page';
import { useMojePodaniSeznamContextInstance } from '@gov-nx/module/page';
import {
	ContentLayout,
	InfoBanner,
	Pagination,
	Tile,
	Tiles,
} from '@gov-nx/ui/web';
import { pageRouteResolver, scrollIntoView } from '@gov-nx/web';
import { MySubmissionsListFilter } from './MySubmissionsListFilter';
import { MySubmissionsListSkeleton } from './MySubmissionsListSkeleton';

export interface MySubmissionsViewProps {
	code: PageCode;
}

export const MySubmissionsList = ({ code }: MySubmissionsViewProps) => {
	const { t } = useTranslation([code]);
	const {
		submissions,
		filter,
		currentPage,
		goToPage,
		numberOfSubmissions,
		query,
	} = useMojePodaniSeznamContextInstance();

	return (
		<ContentLayout customClasses="mt-6">
			<MySubmissionsListFilter code={code} />
			{query.isFetching ? (
				<MySubmissionsListSkeleton />
			) : (
				<section>
					{numberOfSubmissions ? (
						<>
							<Tiles marginTop="l">
								{submissions.map((submission) => (
									<Tile
										key={submission.id}
										icon={{ name: 'chevron-right', type: 'components' }}
										to={pageRouteResolver('moje-podani.detail', {
											submissionId: submission.id,
										})}
										name={submission.name}
										date={
											submission.status.message
												? t('status.' + submission.status.message, {
														namespace: code,
														count: submission.status.date as number,
														date: submission.status.date,
													})
												: undefined
										}>
										<p className="text-(--text-secondary)" />
									</Tile>
								))}
							</Tiles>
							{numberOfSubmissions > filter.pocet ? (
								<footer className="mt-6">
									<Pagination
										color="primary"
										size="m"
										onPage={(event) => {
											scrollIntoView();
											goToPage(event);
										}}
										current={currentPage}
										pageSize={filter.pocet}
										total={numberOfSubmissions}
										wcag-label={t('strankovani')}
									/>
								</footer>
							) : null}
						</>
					) : (
						<InfoBanner
							headline={t('stav.chyba.zatim-jste-nic-nepodali')}
							text={t('stav.chyba.zrejme-jste-podani-nevytvorili')}
						/>
					)}
				</section>
			)}
		</ContentLayout>
	);
};
